// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.7012 10.2607H6.5L9.89941 12.7393L8.60059 16.75L12 14.2715L15.3994 16.75L14.1006 12.7393L17.5 10.2607H13.2979L12 6.25L10.7012 10.2607Z" fill="#80EAFF"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.7012 10.2607H6.5L9.89941 12.7393L8.60059 16.75L12 14.2715L15.3994 16.75L14.1006 12.7393L17.5 10.2607H13.2979L12 6.25L10.7012 10.2607Z" style="fill: currentColor"/></svg>`;

export const LoyaltyPoint: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
